import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiMessageSquare,
  FiClock,
  FiUser,
  FiTag,
  FiArrowUp,
  FiCheckCircle,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function TicketConsole() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [priorityFilter, setPriorityFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [tickets] = useState([
    {
      id: 1,
      ticketId: "TKT-001",
      userId: "USR-001",
      userName: "Rajesh Kumar",
      subject: "Order failed issue",
      category: "Mutual Funds",
      priority: "High",
      status: "Open",
      assignedTo: "Admin-001",
      createdAt: "2024-01-20 10:30 AM",
      slaStatus: "Within SLA",
      lastUpdated: "2024-01-20 11:00 AM",
    },
    {
      id: 2,
      ticketId: "TKT-002",
      userId: "USR-002",
      userName: "Priya Sharma",
      subject: "KYC verification query",
      category: "KYC",
      priority: "Medium",
      status: "In Progress",
      assignedTo: "Admin-002",
      createdAt: "2024-01-19 02:15 PM",
      slaStatus: "Within SLA",
      lastUpdated: "2024-01-20 09:00 AM",
    },
    {
      id: 3,
      ticketId: "TKT-003",
      userId: "USR-003",
      userName: "Amit Patel",
      subject: "SIP bounce issue",
      category: "SIP",
      priority: "High",
      status: "Resolved",
      assignedTo: "Admin-001",
      createdAt: "2024-01-18 04:45 PM",
      slaStatus: "SLA Breached",
      lastUpdated: "2024-01-19 10:30 AM",
    },
  ]);

  const handleAssign = (ticketId) => {
    Swal.fire({
      title: "Assign Ticket",
      html: `
        <select id="assignTo" class="swal2-select">
          <option value="Admin-001">Admin-001</option>
          <option value="Admin-002">Admin-002</option>
          <option value="Admin-003">Admin-003</option>
        </select>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Assign",
      confirmButtonColor: "#006e82",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Assigned!", "Ticket has been assigned.", "success");
      }
    });
  };

  const handleReply = (ticketId) => {
    Swal.fire({
      title: "Reply to Ticket",
      html: `
        <textarea id="replyMessage" class="swal2-textarea" placeholder="Enter your reply..." required></textarea>
        <label style="margin-top: 10px;">
          <input type="checkbox" id="internalNote"> Internal Note (not visible to user)
        </label>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Send Reply",
      confirmButtonColor: "#006e82",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Sent!", "Reply has been sent.", "success");
      }
    });
  };

  const handleClose = (ticketId) => {
    Swal.fire({
      title: "Close Ticket?",
      text: "This ticket will be marked as closed.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Close",
      confirmButtonColor: "#10b981",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Closed!", "Ticket has been closed.", "success");
      }
    });
  };

  const handleEscalate = (ticketId) => {
    Swal.fire({
      title: "Escalate Ticket?",
      text: "This ticket will be escalated to higher priority.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Escalate",
      confirmButtonColor: "#ef4444",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Escalated!", "Ticket has been escalated.", "success");
      }
    });
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case "High":
        return "#ef4444";
      case "Medium":
        return "#f59e0b";
      case "Low":
        return "#10b981";
      default:
        return "#64748b";
    }
  };

  const filteredTickets = tickets.filter((ticket) => {
    const matchesSearch =
      ticket.ticketId.includes(searchTerm) ||
      ticket.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      ticket.subject.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === "all" || ticket.status === statusFilter;
    const matchesPriority = priorityFilter === "all" || ticket.priority === priorityFilter;
    return matchesSearch && matchesStatus && matchesPriority;
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredTickets.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredTickets.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                <div className="content-page-header content-page-headersplit">
                <h5>Ticket Console</h5>
              </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/support/ticket-console">Support</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Ticket Console
                  </li>
                </ol>
              </nav>
            
            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row g-3">
                <div className="col-12 col-md-4">
                  <div className="position-relative">
                    <FiSearch
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#64748b",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by ticket ID, user, or subject..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(0);
                      }}
                      style={{ paddingLeft: "40px" }}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <select
                    className="form-control"
                    value={statusFilter}
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                      setCurrentPage(0);
                    }}
                  >
                    <option value="all">All Status</option>
                    <option value="Open">Open</option>
                    <option value="In Progress">In Progress</option>
                    <option value="Resolved">Resolved</option>
                    <option value="Closed">Closed</option>
                  </select>
                </div>
                <div className="col-12 col-md-3">
                  <select
                    className="form-control"
                    value={priorityFilter}
                    onChange={(e) => {
                      setPriorityFilter(e.target.value);
                      setCurrentPage(0);
                    }}
                  >
                    <option value="all">All Priorities</option>
                    <option value="High">High</option>
                    <option value="Medium">Medium</option>
                    <option value="Low">Low</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Tickets Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>Ticket ID</th>
                          <th>User</th>
                          <th>Subject</th>
                          <th>Category</th>
                          <th>Priority</th>
                          <th>Status</th>
                          <th>Assigned To</th>
                          <th>SLA Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="9">No data available</td>
                          </tr>
                        ) : (
                          currentItems.map((ticket) => (
                            <tr key={ticket.id}>
                              <td style={{ fontWeight: "500" }}>{ticket.ticketId}</td>
                              <td style={{ fontWeight: "500" }}>{ticket.userName}</td>
                              <td>{ticket.subject}</td>
                              <td>
                                <span className="badge" style={{
                                  background: "#f0f9ff",
                                  color: "#006e82",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}>
                                  {ticket.category}
                                </span>
                              </td>
                              <td>
                                <span className="badge" style={{
                                  background: `${getPriorityColor(ticket.priority)}20`,
                                  color: getPriorityColor(ticket.priority),
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}>
                                  {ticket.priority}
                                </span>
                              </td>
                              <td>
                                <span className={ticket.status === "Resolved" || ticket.status === "Closed" ? "badge-active" : ticket.status === "In Progress" ? "badge-pending" : "badge-pending"}>
                                  {ticket.status}
                                </span>
                              </td>
                              <td>{ticket.assignedTo}</td>
                              <td>
                                <span className={ticket.slaStatus === "Within SLA" ? "badge-active" : "badge-pending"}>
                                  {ticket.slaStatus}
                                </span>
                              </td>
                              <td>
                                <div className="table-actions d-flex justify-content-center">
                                  <div
                                    className="delete-table me-2"
                                    onClick={() => handleReply(ticket.ticketId)}
                                    title="Reply"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-comment"></i>
                                  </div>
                                  <div
                                    className="delete-table me-2"
                                    onClick={() => handleAssign(ticket.ticketId)}
                                    title="Assign"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-user"></i>
                                  </div>
                                  {ticket.status !== "Closed" && (
                                    <>
                                      <div
                                        className="delete-table me-2"
                                        onClick={() => handleClose(ticket.ticketId)}
                                        title="Close"
                                        style={{ cursor: "pointer", color: "#10b981" }}
                                      >
                                        <i className="fas fa-check-circle"></i>
                                      </div>
                                      <div
                                        className="delete-table"
                                        onClick={() => handleEscalate(ticket.ticketId)}
                                        title="Escalate"
                                        style={{ cursor: "pointer", color: "#ef4444" }}
                                      >
                                        <i className="fas fa-arrow-up"></i>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
